// Creating two slices for managing Tournaments: Tournament List Slice and Tournament Details Slice

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Smartico } from '../../core/Smartico'
import { RootState } from '../store'
import { TTournament } from '@smartico/public-api/dist/WSAPI/WSAPITypes'

interface TournamentListState {
    tournaments: TTournament[]
    error: string | null
}

const initialTournamentListState: TournamentListState = {
    tournaments: [],
    error: null,
}

export const fetchTournamentsList = createAsyncThunk('tournaments/fetchTournamentsList', async (_, { rejectWithValue }) => {
    try {
        const smarticoApi = await Smartico.apiReady
        const tournaments = await smarticoApi.getTournamentsList()
        return tournaments
    } catch (error) {
        return rejectWithValue('Failed to fetch tournaments list')
    }
})

export const subscribeToTournamentsUpdates = () => async (dispatch: any) => {
    try {
        const smarticoApi = await Smartico.apiReady
        await smarticoApi.getTournamentsList({
            onUpdate: (updatedTournaments: TTournament[]) => {
                if (updatedTournaments && updatedTournaments.length > 0) {
                    dispatch(updateTournaments(updatedTournaments))
                }
            },
        })
    } catch (error) {
        console.error('Error subscribing to tournaments updates:', error)
    }
}

const tournamentListSlice = createSlice({
    name: 'tournaments',
    initialState: initialTournamentListState,
    reducers: {
        updateTournaments(state, action) {
            state.tournaments = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTournamentsList.pending, (state) => {
                state.tournaments = []
                state.error = null
            })
            .addCase(fetchTournamentsList.fulfilled, (state, action) => {
                state.tournaments = action.payload
                state.error = null
            })
            .addCase(fetchTournamentsList.rejected, (state, action) => {
                state.tournaments = []
                state.error = action.payload as string
            })
    },
})

export const { updateTournaments } = tournamentListSlice.actions
export const selectAllTournaments = (state: RootState) => state.tournaments.tournaments
export default tournamentListSlice.reducer